import {
  SET_UNSUPPORTED_BROWSER_ALERT_OPEN,
  SET_UNSUPPORTED_BROWSER_ALERT_CLOSED,
  SET_OFFLINE_ALERT_OPEN,
  SET_OFFLINE_ALERT_CLOSED,
  ONLINE,
  OFFLINE,
} from '../actions/browserWarnings';

export const initialState = {
  isUnsupportedBrowserAlertOpen: false,
  isOfflineAlertOpen: false,
  isOffline: false,
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case SET_UNSUPPORTED_BROWSER_ALERT_OPEN: {
      return {
        ...state,
        isUnsupportedBrowserAlertOpen: true,
      };
    }
    case SET_UNSUPPORTED_BROWSER_ALERT_CLOSED: {
      return {
        ...state,
        isUnsupportedBrowserAlertOpen: false,
      };
    }
    case SET_OFFLINE_ALERT_OPEN: {
      return {
        ...state,
        isOfflineAlertOpen: true,
      };
    }
    case SET_OFFLINE_ALERT_CLOSED: {
      return {
        ...state,
        isOfflineAlertOpen: false,
      };
    }
    case OFFLINE: {
      return {
        ...state,
        isOffline: true,
      };
    }
    case ONLINE: {
      return {
        ...state,
        isOffline: false,
      };
    }
    default:
      return state;
  }
}
